module.exports = __webpack_public_path__ + "img/svg/invite-friend-separator.67486eb52d3d4bc4a8765498657ebdd5.svg";